import { Component } from '@angular/core'

@Component({
  selector: 'header-only-layout',
  styles: [`
    :host { display: block; }
  `],
  template: `
    <div class="header-layout">
      <ng-content select="[header]"></ng-content>
      <div class="content-wrapper">
        <div class="container-fluid">
          <div class="row">
            <div id="detail-content" class="detail-content">
              <div class="inner-detail-content">
                <ng-content select="[main]"></ng-content>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `
})
export class HeaderOnlyLayoutComponent {}
